module.exports = __webpack_public_path__ + "assets/img/kv-c6f56785.jpg";